import { ReturnStatusZod } from "@redotech/redo-model/return-status";
import * as z from "zod/v4";

const creditMemoSchema_ = z.object({
  enabled: z.boolean(),
  restock: z.boolean(),
  triggerStatus: ReturnStatusZod,
});
export const creditMemoSchema: z.ZodType<CreditMemoSchema> = creditMemoSchema_;
export interface CreditMemoSchema extends z.infer<typeof creditMemoSchema_> {}

export const setApparelMagicIntegration = {
  name: "setApparelMagicIntegration" as const,
  input: z.object({
    apiKey: z.string().min(1, "API key is required"),
    companyId: z.string().min(1, "Company ID is required"),
    orderNameField: z.string().min(1, "Order name field is required"),
    inventoryItemSkuField: z
      .string()
      .min(1, "Inventory item SKU field is required"),
    creditMemo: creditMemoSchema_,
  }),
  output: z.object({}),
};

export type SetApparelMagicIntegrationInput = z.infer<
  typeof setApparelMagicIntegration.input
>;

export const updateApparelMagicIntegration = {
  name: "updateApparelMagicIntegration" as const,
  input: z.object({
    apiKey: z.string().optional(),
    companyId: z.string().optional(),
    orderNameField: z.string().optional(),
    inventoryItemSkuField: z.string().optional(),
    creditMemo: creditMemoSchema_.optional(),
  }),
  output: z.object({}),
};

export type UpdateApparelMagicIntegrationInput = z.infer<
  typeof updateApparelMagicIntegration.input
>;

export const getApparelMagicIntegration = {
  name: "getApparelMagicIntegration" as const,
  input: z.object({}),
  output: z.object({
    apparelMagicIntegration: z.optional(
      z.object({
        companyId: z.string(),
        orderNameField: z.string(),
        inventoryItemSkuField: z.string(),
        creditMemo: creditMemoSchema_,
        // API key is intentionally omitted from the output for security
      }),
    ),
  }),
};

export type GetApparelMagicIntegrationOutput = z.infer<
  typeof getApparelMagicIntegration.output
>;

export const disconnectApparelMagicIntegration = {
  name: "disconnectApparelMagicIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
